export default {
  //设置cookie
  setCookie: function (c_name, value, expiredays, path, domain) {
    // domain只能设置为当前域名的更高级域名，
    // 如：在www.tongshike.cn中可以设置为.tongshike.cn而不能设置为ua.tongshike.cn
    var exdate = new Date();
    exdate.setTime(exdate.getTime() + expiredays * 1000);
    document.cookie = c_name + "=" + escape(value) +
      ((expiredays == null) ? "" : "; expires=" + exdate.toGMTString()) +
      ((path == null) ? "" : "; path=" + escape(path)) +
      ((domain == null) ? "" : "; domain=" + escape(domain));
  },
  //获取cookie
  getCookie: function (c_name) {
    if (document.cookie.length > 0) {
      var c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        var c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) c_end = document.cookie.length;
        return unescape(document.cookie.substring(c_start, c_end));
      }
    }
    return "";
  },
  delCookie: function (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  },
  getUrlParam: function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) {
      return decodeURIComponent(r[2]);
      //这里为什么是从第三个字符解析呢？不知道这样理解对不对，因为路径后面的参数形式为参数名=参数值，而第一个字符为参数名，第二个为=，第三个就为参数值了。。。因为下面调用的时候得出的就是参数值
    }
    return null; //返回参数值
  },
  getUrlParam2: function (paraName) {
    var url = document.location.toString();
    var arrObj = url.split("?");

    if (arrObj.length > 1) {
      var arrPara = arrObj[1].split("&");
      var arr;

      for (var i = 0; i < arrPara.length; i++) {
        arr = arrPara[i].split("=");

        if (arr != null && arr[0] == paraName) {
          return arr[1];
        }
      }
      return "";
    } else {
      return "";
    }
  },
  getDate: function () {
    var date = new Date();
    var year = date.getFullYear();
    var month = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    // var day = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六")[date.getDay()];
    var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    var minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    var currentTime = year + "-" + month + "-" + day + " " + hour + ":" + minute;
    return currentTime;
  },
  getLocalTime: function (datetimes) {
    var date = new Date(datetimes);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
    var h = date.getHours() < 10 ? "0" + date.getHours() + ':' : date.getHours() + ':';
    var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    return Y + M + D + " " + h + m;
  },
  buildResourcePath: function (src) {
    if (!src) {
      return "";
    }
    var httpReg = /^(http|https)/;
    if (!httpReg.test(src)) {
      src = "https://leicloud.ulearning.cn/" + src;
    }
    return src;
  },
  handleImg: function (imgUrl, beforeUrl, discussType) {
    if (imgUrl && imgUrl != '' && discussType != 1) {
      if (imgUrl.indexOf("http") != 0) {
        return beforeUrl + imgUrl;
      } else {
        return imgUrl;
      }
    } else {
      return require('../../common/img/wo_nohead.png');
    }

  }
}



// WEBPACK FOOTER //
// ./src/common/js/common.js